import React from "react";
import api from "../servicios/api";
import "./Publico.css";

import { Link } from "react-router-dom";

import fondo from "../assets/fondo.jpg";
import logoPMT from "../assets/logo_pmt.png";
import logoMuni from "../assets/logo_muni.png";

class Publico extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      placa: "",
      tipo: "",
      mensaje: "",
      cargando: false
    };
  }

  cambioValor = (e) => {
    this.setState({
      [e.target.name]: e.target.value.toUpperCase()
    });
  };

  consultarMultas = (e) => {
    e.preventDefault();

    if (!this.state.placa || !this.state.tipo) {
      this.setState({
        mensaje: "Ingrese tipo y número de placa."
      });
      return;
    }

    this.setState({
      cargando: true,
      mensaje: ""
    });

fetch(api + "consultas/multas", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
  body: JSON.stringify({
    tipo: this.state.tipo,
    placa: this.state.placa
  })
})
  .then(async respuesta => {
    const datos = await respuesta.json();

    if (!respuesta.ok) {
      throw new Error(datos.message || datos.mensaje || "Error en la consulta");
    }

    return datos;
  })
  .then(datos => {
    this.setState({
      cargando: false,
      mensaje: datos.mensaje
    });
  })
  .catch(error => {
    this.setState({
      cargando: false,
      mensaje: error.message || "Error al realizar la consulta."
    });
  });
}

  render() {
    return (
      <div
        className="inicio-container"
        style={{
          backgroundImage: `url(${fondo})`
        }}
      >
        <div className="inicio-capa">

          <img
            src={logoPMT}
            alt="PMT"
            className="logo-izquierdo"
          />

          <img
            src={logoMuni}
            alt="Municipalidad"
            className="logo-derecho"
          />

     <div className="login-publico">
  <Link
    to="/login"
    className="btn btn-success btn-sm"
  >
    Iniciar Sesión
  </Link>
</div>



          <div className="consulta-box">

            <h2>Consulta de Multas</h2>

            <p>
              Ingrese el tipo y número de placa para verificar si posee multas pendientes.
            </p>

            <form onSubmit={this.consultarMultas}>

              <div className="mb-3">
                <label>Tipo de placa</label>

                <select
                  name="tipo"
                  className="form-control"
                  value={this.state.tipo}
                  onChange={this.cambioValor}
                >
                  <option value="">Seleccione tipo</option>
                  <option value="1">A</option>
                  <option value="2">P</option>
                  <option value="3">C</option>
                  <option value="4">M</option>
                </select>
              </div>

              <div className="mb-3">
                <label>Número de placa</label>

                <input
                  type="text"
                  name="placa"
                  className="form-control"
                  placeholder="P123ABC"
                  value={this.state.placa}
                  onChange={this.cambioValor}
                />
              </div>

              <button
                className="btn btn-primary w-100"
                disabled={this.state.cargando}
              >
                {this.state.cargando
                  ? "Consultando..."
                  : "Consultar"}
              </button>

            </form>

            {this.state.mensaje && (
              <div className="alert alert-info mt-3 text-center">
                {this.state.mensaje}
              </div>
            )}

          </div>

        </div>
      </div>
    );
  }
}

export default Publico;